module.exports = __webpack_public_path__ + "static/che6-0dd33bf13df66e0b0f9752c2f32fef31.jpg";